export default __webpack_public_path__ + "static/media/discussion3image1.7012e1c8.png";